import * as Yup from "yup";
import FormDefault from "../../components/Forms/FormDefault";
import { Request } from "../../hooks/Request";
import { validateType } from "../../utils/constant";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";

const CUSTOMS_AGENT_FIELD = "agenteDespachante";
const PROVIDERS_DROPDOWN_URL = "/Dropdown/providers/options";
const CUSTOMS_AGENCY_PROVIDER_TYPE = "AGENCIA ADUANERA";

function normalizeProviderType(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

function isCustomsAgencyProvider(option) {
  if (!option?.data) return false;

  const providerData =
    typeof option.data === "string" ? JSON.parse(option.data) : option.data;

  return (
    normalizeProviderType(providerData?.tipo_proveedor) ===
    CUSTOMS_AGENCY_PROVIDER_TYPE
  );
}

const listFields = [
  CUSTOMS_AGENT_FIELD,
  "nroDim",
  "fechaDam",
  "fechaPagoDeTributos",
  "asignaciónDeCanal",
  "almacénDestino",
  "fechaDeRecepción",
  // "documentosOriginales",
  // "tránsitoTerrestre",
];

export const FormNacionalizacion = (props) => {
  const { procedure } = props;
  const procedureId = procedure?.id || procedure?.procedureId;

  const { data, loading } = Request({
    urlApi: procedureId
      ? `/Procedure/${procedureId}/datasets?${listFields.map((field) => `fieldnames=${field}`).join("&")}`
      : null,
  });

  const fields = data
    ? listFields
        .map((fieldName) => Object.values(data).find((f) => f?.name === fieldName))
        .filter((f) => f && f.id && f.name)
    : [];

  function dataFields(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]: element.validate
          ? validateType[element.type] || null
          : null,
      };
    });
    return aux;
  }

  function dataIntialValues(list) {
    let aux = {};
    list?.forEach((element) => {
      aux = {
        ...aux,
        [element.name]:
          (element.initial === "false" ? false : element.initial) || "",
      };
    });
    return aux;
  }

  async function onSubmit(values, resetForm, fields) {
    const result = await Promise.all(
      fields.map(async (element) => {
        return {
          Value:
            values[element.name] || values[element.name] === 0
              ? values[element.name]
              : "",
          ProcedureId: procedureId,
          FieldId: element.id,
          name: element.name,
          url: element.url,
          type: element.type,
        };
      })
    );
    await requestAuth("post", "/dataset", result.filter((n) => n))
      .then(() => {
        toast.success("Envio exitoso");
      })
      .catch(() => {
        toast.error("Error en el envio");
      });
  }

  if (!procedureId || !loading) {
    return null;
  }

  return (
    <div>
      <FormDefault
        tittle="Formulario de Nacionalización"
        fields={fields.map((value, index) => {
          const isCustomsAgent = value.name === CUSTOMS_AGENT_FIELD;

          return {
            ...value,
            id: procedureId,
            fieldId: value.id,
            label: value.label,
            labelCustom: (
              <>
                <span className="text-green-600">{index + 1}.</span>{" "}
                {value.label}
              </>
            ),
            name: value.name,
            validate: value.validate,
            placeholder: isCustomsAgent
              ? "Seleccione agente despachante"
              : "Complete el campo",
            type: isCustomsAgent
              ? "selectGet"
              : value.type === "fileRead"
                ? "file"
                : value.type,
            typeInput: isCustomsAgent
              ? "selectGet"
              : value.type === "fileRead"
                ? "file"
                : value.type,
            initial: value.initial ? value.initial : null,
            urlApi: isCustomsAgent
              ? PROVIDERS_DROPDOWN_URL
              : value.url
                ? value.url.includes("/")
                  ? value.url
                  : `/Dropdown/${value.url}/options`
                : "",
            urlInitial: isCustomsAgent ? "providers" : value.url,
            remoteSearch: isCustomsAgent,
            optionFilter: isCustomsAgent
              ? isCustomsAgencyProvider
              : undefined,
            value: "name",
            labelOption: "name",
          };
        })}
        initialValues={dataIntialValues(fields)}
        validationSchema={Yup.object().shape(dataFields(fields))}
        onSubmit={async (values, resetForm) =>
          await onSubmit(values, resetForm, fields)
        }
        buttonName="Guardar"
      />
    </div>
  );
};
